import { CSSProperties } from 'react';

interface VerticalLayoutProps {
  children?: any;
  className?: string;
  style?: CSSProperties;
}

const VerticalLayout = ({ children, className, style }: VerticalLayoutProps) => {
  return (
    <div className={`flex flex-column ${className}`} style={style}>
      {children}
    </div>
  );
};

export default VerticalLayout;
